import * as CandidateService from "@app/services/CandidateService";
import { showSuccessMessageSaveData } from "@pages/candidate/Common";
import React, { useEffect, useState } from 'react';
import { toast } from "react-toastify";

const CandidateCVInfo = (props) => {
    const [curriculumVitae, setCurriculumVitae] = useState({});
    const [isEditCVs, setIsEditCVs] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const {
        cvInfo,
        isEditCandidateCVs = false,
        mode = 'Edit',
        onChange
    } = props

    useEffect(() => {
        setCurriculumVitae(cvInfo);
        setIsEditCVs(isEditCandidateCVs);
    }, [cvInfo, isEditCandidateCVs])

    const updateCandidateCVs = () => {
        setIsLoading(true)
        CandidateService.updateCandidateCVDetail({
            candidate_id: curriculumVitae.candidate_id ?? curriculumVitae.candidate,
            cvs: curriculumVitae}).then((res) => {
            showSuccessMessageSaveData(res.sts_code)
            setIsEditCVs(false)
        }).catch((error) => {
            toast.error(`Có lỗi xảy ra trong quá trình xử lý.`);
        }).finally(() => {
            setIsLoading(false)
        });
    };

    const onChangeCandidateCVs = (event) => {
        const temp = {...curriculumVitae}
        temp[event.target.name] = event.target.value
        setCurriculumVitae(temp)

        if (onChange) {
            onChange(temp);
        }
    }

    return (
        <>
            <div className='card card-default'>
                <div className='card-header'>
                    <h3 className='card-title text-bold'>Thông tin CV</h3>
                    {mode !=='Search' &&
                    <div className='card-tools'>
                        {isEditCVs &&
                            <>
                                <button type='button'
                                        className='btn btn-default mr-2'
                                        onClick={() => {
                                            setIsEditCVs(false);
                                        }}
                                >
                                    Cancel
                                </button>

                                <button type='button'
                                        className='btn btn-primary'
                                        onClick={() => {
                                            updateCandidateCVs();
                                        }}
                                >
                                    Save
                                </button>
                            </>
                        }
                        {!isEditCVs &&
                            <button type='button'
                                    className='btn btn-default'
                                    onClick={() => {
                                        setIsEditCVs(true);
                                    }}
                            >
                                Edit
                            </button>
                        }
                    </div>
                    }
                </div>
                <div className='card-body'>
                    {curriculumVitae &&
                        <>
                            <div className='input-group'>
                                <label className={'w-100'}>Phân loại CV</label>
                                <select className='form-control'
                                        name={'cv_type'}
                                        disabled={!isEditCVs}
                                        value={curriculumVitae.cv_type ? curriculumVitae.cv_type.toString() : ''}
                                        onChange={event => onChangeCandidateCVs(event)}>
                                            <option value=''></option>
                                            <option value='0'>N/A</option>
                                            <option value='1'>Sơ sài</option>
                                            <option value='2'>Có title nhưng chưa có mô tả cviec
                                            </option>
                                </select>
                            </div>
                            <div className='input-group mt-3'>
                                <label className={'w-100'}>Note (CV)</label>
                                <textarea className='form-control'
                                          value={curriculumVitae.note ? curriculumVitae.note : ''}
                                          name={'note'}
                                          disabled={!isEditCVs}
                                          onChange={event => onChangeCandidateCVs(event)}/>
                            </div>
                            <div className='input-group mt-3'>
                                <label className={'w-100'}>Trạng thái UV cam kết thông tin</label>
                                <select className='form-control'
                                        name={'commit_state'}
                                        disabled={!isEditCVs}
                                        value={curriculumVitae.commit_state ? curriculumVitae.commit_state.toString() : ''}
                                        onChange={event => onChangeCandidateCVs(event)}>
                                    <option value=''></option>
                                    <option value='1'>Chưa cam kết</option>
                                    <option value='2'>Đã cam kết</option>
                                </select>
                            </div>
                            <div className='input-group mt-3'>
                                <label className={'w-100'}>Có People in Ref Check</label>
                                <select className='form-control'
                                        name={'has_prefer_check'}
                                        disabled={!isEditCVs}
                                        value={curriculumVitae.has_prefer_check ? curriculumVitae.has_prefer_check.toString() : ''}
                                        onChange={event => onChangeCandidateCVs(event)}>
                                            <option value=''></option>
                                            <option value='false'>Không</option>
                                            <option value='true'>Có</option>
                                </select>
                            </div>
                            <div className='input-group mt-3'>
                                <label className={'w-100'}>Trạng thái nhập vào pm</label>
                                <select className='form-control'
                                        name={'pm_input_state'}
                                        disabled={!isEditCVs}
                                        value={curriculumVitae.pm_input_state ? curriculumVitae.pm_input_state.toString() : ''}
                                        onChange={event => onChangeCandidateCVs(event)}>
                                            <option value=''></option>
                                            <option value='0'>N/A</option>
                                            <option value='1'>Rồi</option>
                                            <option value='2'>Chưa</option>
                                </select>
                            </div>
                        </>
                    }
                </div>
            </div>
        </>
    )
}

export default CandidateCVInfo;
